import { Heading1 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { color, container, fontSize, fontWeight, screen, spacing } from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledHeroWrapper = styled.div``;

export const StyledHero = styled.div`
  position: relative;
  overflow: hidden;
  background-image: ${() =>
    `url('${getPublicPath('/images/companies/hero-mask.svg')}')`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center top;
`;

export const StyledHeroContainer = styled.div`
  margin: auto;
  max-width: ${container('xl')};
  padding: ${spacing('xl5')} ${spacing('md')} ${spacing('xl5')};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing('xl2')};
  z-index: 1;
  position: relative;

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
    align-items: flex-start;
    gap: ${spacing('xl5')};
  }
`;

export const StyledHeroText = styled.div`
  max-width: 35rem;
  color: ${color('text_white')};
  line-height: 1.5;
  text-align: center;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.4;
  }
`;

export const StyledHeroTitle = styled(Heading1)`
  margin-bottom: ${spacing('lg')};
`;

export const StyledHeroForm = styled.form`
  color: ${color('text_white')};
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing('xl')};
  z-index: 1;
  position: relative;
  max-width: 34rem;
  color: ${color('text_white')};
  font-size: ${fontSize('lg')};
  line-height: 1.4;

  .phoneNumber {
    max-width: 20rem;
  }

  .phoneNumber {
    max-width: 20rem;
  }
`;

export const StyledFormHeader = styled.div`
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  font-size: ${fontSize('md')};
  line-height: 1.5;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;

export const StyledTerms = styled.span`
  font-size: ${fontSize('xs')};
  line-height: 1.333;

  a {
    font-weight: ${fontWeight('black')};
    color: ${color('link_inverse')};

    &:hover,
    &:focus {
      color: ${color('link_inverse_hover')};
    }

    &:active {
      color: ${color('link_inverse_active')};
    }
  }
`;
